export default "__VITE_ASSET__CaXzeYpk__"